/**
 * Canonical media types for calculation formulas.
 */
export const HOARDING_SUBCATEGORY_ID = '643cdf01779bc024c189cf95';

export const MEDIA_TYPES = {
  PRINT_MEDIA: 'Print Media',
  RADIO: 'Radio',
  TELEVISION: 'television',
  HOARDING: 'Hoarding',
  MULTIPLEX: 'Multiplex',
  DOOH: 'DOOH',
  AIRPORT: 'Airport',
  OFFLINE_BTL: 'Offline BTL',
  OTHER: 'Other',
};

/**
 * Map a product to its canonical media type.
 * Supports both data shapes:
 *  - dashboard:  product.mediaCategory (e.g. "television", "radio", "print")
 *  - admin/old:  product.ProductCategoryName / product.ProductSubCategoryName
 */
export function getMediaTypeFromProduct(product) {
  const mediaCategory = product?.mediaCategory || '';
  const category = product?.ProductCategoryName || '';
  const subCategory = product?.ProductSubCategoryName || '';
  const subCategoryId = product?.ProductSubCategory || '';

  // Prefer canonical mediaCategory if present
  if (mediaCategory === 'Multiplex ADs' || mediaCategory === 'multiplex') return MEDIA_TYPES.MULTIPLEX;
  if (mediaCategory === 'hoarding') return MEDIA_TYPES.HOARDING;
  if (mediaCategory === 'dooh') return MEDIA_TYPES.DOOH;
  if (mediaCategory === 'television') return MEDIA_TYPES.TELEVISION;
  if (mediaCategory === 'radio') return MEDIA_TYPES.RADIO;
  if (mediaCategory === 'airport' || mediaCategory === 'Airport') return MEDIA_TYPES.AIRPORT;
  if (mediaCategory === 'print') return MEDIA_TYPES.PRINT_MEDIA;
  if (mediaCategory === 'offlinebtl' || mediaCategory === 'Offline BTL') return MEDIA_TYPES.OFFLINE_BTL;

  // Fallback to category / subcategory names (admin's historic shape)
  if (category === 'Multiplex ADs') return MEDIA_TYPES.MULTIPLEX;
  if (
    subCategory === 'Hoardings' ||
    subCategoryId === HOARDING_SUBCATEGORY_ID
  ) {
    return MEDIA_TYPES.HOARDING;
  }
  if (subCategory === 'Digital ADs') return MEDIA_TYPES.DOOH;
  if (subCategory === 'television') return MEDIA_TYPES.TELEVISION;
  if (subCategory === 'Radio' || category === 'Radio') return MEDIA_TYPES.RADIO;
  if (subCategory === 'Airport' || category === 'Airport') return MEDIA_TYPES.AIRPORT;
  if (
    subCategory === 'Print Media' ||
    category === 'Print Media' ||
    category === 'Newspapers/ Magazines'
  ) {
    return MEDIA_TYPES.PRINT_MEDIA;
  }
  if (subCategory === 'Offline BTL' || category === 'Offline BTL') return MEDIA_TYPES.OFFLINE_BTL;

  return MEDIA_TYPES.OTHER;
}
